import type { AdminSponsorshipApplication } from '@inflip/contracts/admin';
import { SOCIAL_PLATFORM_LABELS } from '@inflip/shared';

/** 지원 시점에 조건을 통과시킨 채널 — "유튜브 3.2만" 처럼. 조건 없는 협찬이면 — */
export function qualifiedChannelLabel(a: AdminSponsorshipApplication): string {
  if (!a.qualifiedPlatform) return '—';
  const followers =
    a.qualifiedFollowerCount === null ? '' : ` ${a.qualifiedFollowerCount.toLocaleString('ko-KR')}`;
  return `${SOCIAL_PLATFORM_LABELS[a.qualifiedPlatform]}${followers}`;
}

/** 협찬 제목 + 업체명 (삭제된 협찬은 표시) */
export function SponsorshipTitleCell({
  a,
  linked = false,
}: {
  a: AdminSponsorshipApplication;
  /** 링크 안에 넣을 때 — 마우스를 올리면 제목에 밑줄 (부모에 group 클래스) */
  linked?: boolean;
}) {
  return (
    <div className="min-w-0">
      <div
        className={`truncate font-semibold ${linked ? 'group-hover:text-brand group-hover:underline' : ''}`}
      >
        {a.sponsorshipTitle}
        {a.sponsorshipDeleted && (
          <span className="ml-1.5 text-xs font-medium text-muted-foreground">(삭제된 협찬)</span>
        )}
      </div>
      <div className="truncate text-xs text-muted-foreground">{a.businessName}</div>
    </div>
  );
}
